<template>
  <div class="row publication-row">
    <div class="col-12 col-lg-4 mb-5 pb-5 pe-xxl-5" v-for="publication in publications">
      <publication-topic-card :publication="publication" />
    </div>
  </div>
</template>
<script>
  import PublicationTopicCard from './PublicationTopicCard';

  export default {
    name: 'TopicPublicationList',
    props: {
      publications: {
        type: Array,
        required: true
      }
    },
    components: {
      PublicationTopicCard,
    },
  };
</script>

